// mutations
const PAPELERIA_PRODUCTS_SUBCATEGORIES_ALL = (state, papeleriaProductsSubCategories) => {
  if (papeleriaProductsSubCategories.code === 1) {
    state.papeleriaProductsSubCategories = papeleriaProductsSubCategories.data
    state.status = 'success'
  } else {
    alert(papeleriaProductsSubCategories.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_SUBCATEGORIES_FORM = (state, papeleriaProductsSubCategories) => {
  if (papeleriaProductsSubCategories.code === 1) {
    state.papeleriaProductsSubCategories = papeleriaProductsSubCategories.data
    state.status = 'success'
  } else {
    alert(papeleriaProductsSubCategories.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_SUBCATEGORIES_SHOW = (state, papeleriaProductsSubCategories) => {
  if (papeleriaProductsSubCategories.code === 1) {
    state.papeleriaProductsSubCategories = papeleriaProductsSubCategories.data
    state.status = 'success'
  } else {
    alert(papeleriaProductsSubCategories.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_SUBCATEGORIES_CREATE = (state, papeleriaProductsSubCategories) => {
  if (papeleriaProductsSubCategories.code === 1) {
    state.papeleriaProductsSubCategories = papeleriaProductsSubCategories.data
    state.status = 'success'
    alert(papeleriaProductsSubCategories.message)
  } else {
    alert(papeleriaProductsSubCategories.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_SUBCATEGORIES_UPDATE = (state, papeleriaProductsSubCategories) => {
  if (papeleriaProductsSubCategories.code === 1) {
    state.papeleriaProductsSubCategories = papeleriaProductsSubCategories.data
    state.status = 'success'
    alert(papeleriaProductsSubCategories.message)
  } else {
    alert(papeleriaProductsSubCategories.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_SUBCATEGORIES_DELETE = (state, papeleriaProductsSubCategories) => {
  if (papeleriaProductsSubCategories.code === 1) {
    state.papeleriaProductsSubCategories = papeleriaProductsSubCategories.data
    state.status = 'success'
    alert(papeleriaProductsSubCategories.message)
  } else {
    alert(papeleriaProductsSubCategories.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_SUBCATEGORIES = (state, papeleriaProductsSubCategories) => {
  if (papeleriaProductsSubCategories.code === 1) {
    state.papeleriaProductsSubCategories = papeleriaProductsSubCategories.data
    state.status = 'success'
    // alert(papeleriaProductsSubCategories.message)
  } else {
    alert(papeleriaProductsSubCategories.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_FILTER_SUBCATEGORIES = (state, papeleriaProductsSubCategories) => {
  if (papeleriaProductsSubCategories.code === 1) {
    state.papeleriaProductsSubCategories = papeleriaProductsSubCategories.data
    state.status = 'success'
    // alert(papeleriaProductsSubCategories.message)
  } else {
    alert(papeleriaProductsSubCategories.message)
    state.status = 'error'
  }
}

export default {
  PAPELERIA_PRODUCTS_SUBCATEGORIES_ALL,
  PAPELERIA_PRODUCTS_SUBCATEGORIES_FORM,
  PAPELERIA_PRODUCTS_SUBCATEGORIES_SHOW,
  PAPELERIA_PRODUCTS_SUBCATEGORIES_CREATE,
  PAPELERIA_PRODUCTS_SUBCATEGORIES_UPDATE,
  PAPELERIA_PRODUCTS_SUBCATEGORIES_DELETE,
  PAPELERIA_PRODUCTS_SUBCATEGORIES,
  PAPELERIA_PRODUCTS_FILTER_SUBCATEGORIES
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/products/subcategories/mutations.js